import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Rating from '@material-ui/lab/Rating'
import axios from 'axios'
import Constant from '../../Constant'
class BoatRatingList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    cat: this.props.match.params.boatType,
  }
  deleteProducts = () => { }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId
    await axios
      .get(Constant.getAPI() + `/cruise/get-ratings/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'rating_images',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (rating_images) => {
            if (!rating_images || !Array.isArray(rating_images) || rating_images.length === 0 || !rating_images[0]) {
              return (
                <img
                  src="./assets/images/icon.png"
                  className="img-fluid img-40"
                  alt="tbl"
                />
              )
            }

            const imagePath = rating_images[0].image_path
            const imageUrl = imagePath ? Constant.getImage() + imagePath : './assets/images/icon.png'

            return (
              <div>
                {imagePath && imagePath.indexOf('.mp4') !== -1 ? (
                  <video
                    width="250"
                    controls
                  >
                    <source
                      src={imageUrl}
                      type="video/mp4"
                    />
                  </video>
                ) : (
                  <img
                    src={imageUrl}
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'rated_by_username',
        label: `User Name`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Comment',
        label: `Comment`,
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: 'rating',
        label: `Rating`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (rating) => {
            return (
              <Rating
                name="simple-controlled"
                value={rating}
              />
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} Rating List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} Rating List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatRatingList
